import { Container, Image, Button, Row, Col, Accordion } from 'react-bootstrap';
import {
    ContactUsBanner,
    ContactUsFaq,
    FaqContact,
    FaqContactTitle,
} from './contactUsStyle';
import {
    Title,
    WriteReviewSection,
    ReviewRightSection,
    RightBanner,
    BannerBlueWrapper,
    BannerBlueTitle,
    BannerBlueText,
    BadgeSmallText,
} from '../../../components/common/commonSubBanner/commonSubBannerStyle';
import StoryBanner from "../../../assests/images/storybanner.webp";
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { contactUsFaqHandler } from '../../../redux/slices/faq/contactUsFaq-slice';
import { FaqText } from '../../Faq/FaqStyle';
import { MESSAGE } from '../../../utils/message';
import MetaComponent from '../../../components/common/metaComponent';

const ContactUs = () => {
    const dispatch: any = useDispatch()
    const contactUsFaqList = useSelector((state: any) => state?.contactUsFaq?.data?.data)
    useEffect(() => {
        dispatch(contactUsFaqHandler())
    }, [])
    return (
        <>
            <MetaComponent
                keywords="nonprofits, non-profits, not for profits, volunteer, donate, donation, volunteering, ratings, rate, best non-profits, best nonprofits, best charities, top nonprofits, top charities, top non-profits, charitable giving, giving to nonprofits"
                description="Get in touch with GreatNonprofits for support, inquiries, or feedback. Email us at support@greatnonprofits.org for assistance. We're here to help!"
                ogTitle="Contact Us Today | GreatNonprofits"
                ogDescription="Get in touch with GreatNonprofits for support, inquiries, or feedback. Email us at support@greatnonprofits.org for assistance. We're here to help!"
                ogUrl="https://new.greatnonprofits.org/contact-us/"
                ogImage="https://cdn.greatnonprofits.org/img/gnp-facebook-share-lg.png"
                twitterTitle="Contact Us Today | GreatNonprofits"
                twitterDescription="Get in touch with GreatNonprofits for support, inquiries, or feedback. Email us at support@greatnonprofits.org for assistance. We're here to help!"
                twitterUrl="https://new.greatnonprofits.org/contact-us/"
                twitterImage="https://cdn.greatnonprofits.org/img/gnp-facebook-share-lg.png"
                canonicalUrl="https://new.greatnonprofits.org/contact-us/"
            />
            <ContactUsBanner>
                <WriteReviewSection className="write-review-banner">
                    <Container className="cont-w">
                        <Row>
                            <Col lg={6} sm={12} md={12}>
                                <Title>{MESSAGE.customerSupport}</Title>
                                <BannerBlueWrapper className="blue-banner">
                                    <BannerBlueTitle>{MESSAGE.contactGreatNonprofits}</BannerBlueTitle>
                                    <BannerBlueText>Monday to Friday, 8am to 4pm PST</BannerBlueText>
                                </BannerBlueWrapper>

                                <BadgeSmallText className="base-small-text">Add a Logo Badge to Your Website</BadgeSmallText>
                            </Col>
                            <Col lg={6} sm={12} md={12}>
                                <RightBanner className="left_banner">
                                    <ReviewRightSection className="review-right-image">
                                        <Image src={StoryBanner} alt="ReviewImage" />
                                    </ReviewRightSection>
                                </RightBanner>
                            </Col>
                        </Row>
                    </Container>
                </WriteReviewSection>
            </ContactUsBanner>

            <ContactUsFaq>
                <Container className="cont-w">

                    <FaqContact>

                        <FaqContactTitle>{MESSAGE.mostFAQText}</FaqContactTitle>

                        <Accordion className='accordion-wrapper' defaultActiveKey="0">
                            {contactUsFaqList?.slice(0, 8).map((faq: any, index: number) => (
                                <Accordion.Item eventKey={faq.id} key={index + 1}>
                                    <Accordion.Header><FaqText className='faqs-text'> {faq.question} </FaqText></Accordion.Header>
                                    <Accordion.Body>
                                        {faq.answer}
                                    </Accordion.Body>
                                </Accordion.Item>
                            ))}
                        </Accordion>

                        <Button className="btn-outline-success-blue" onClick={() => window.location.href = "https://greatnonprofits.freshdesk.com/support/home"}>{MESSAGE.seeAllFAQ}</Button>

                    </FaqContact>
                </Container>
            </ContactUsFaq>
        </>
    )
};
export default ContactUs;